import type { EmptyReturnBoardItem } from '@chukua/common';
import { useState } from 'react';
import { useToast } from '../../../shared/hooks/use-toast';
import { markEmptyReturned } from '../deadlines.api';

/** Which container the "Mark returned" modal is open for, and the submit that records it. A form error stays in the modal, the confirmation is a toast. */
export function useMarkReturned(onReturned: () => void) {
  const [target, setTarget] = useState<EmptyReturnBoardItem | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const toast = useToast();

  function open(item: EmptyReturnBoardItem) {
    setError(null);
    setTarget(item);
  }

  async function submit(returnedOn: string): Promise<void> {
    if (!target) return;
    setSubmitting(true);
    setError(null);
    try {
      await markEmptyReturned(target.jobId, target.containerId, { returnedOn });
      toast.success(`Container ${target.containerNumber} marked returned`);
      setTarget(null);
      onReturned();
    } catch {
      setError('Could not record the return — check the date and try again.');
    } finally {
      setSubmitting(false);
    }
  }

  return { target, error, submitting, open, close: () => setTarget(null), submit };
}
